import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate, useParams } from "react-router-dom";
import { FiPlus, FiSearch } from "react-icons/fi";
import { Checkbox } from "primereact/checkbox";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  API_CONTACT_GROUP_MEMBER_UPLOAD,
  API_CONTACT_GROUP_LIST,
} from "../../../service/url";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { toast } from 'react-toastify';

const ContactGroupList = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { checkAuth } = useAuth();
  const [searchValue, setSearchValue] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [newGroup, setNewGroup] = useState({
    name: "",
  });

  const [groupsData, setGroupsData] = useState([]);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  useEffect(() => {
    getApiCall(API_CONTACT_GROUP_LIST, {}).then(onListSuccess).catch(onError);
  }, []);

  function onListSuccess(resp) {
    if (resp?.length > 0) {
      resp = resp.filter((item) => {
        return item.id !== id;
      });
    }
    setGroupsData(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const filteredGroups = groupsData.filter((group) =>
    group.group_name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleImportMembers = () => {
    if (selectedGroups.length < 1) {
      // setToastProps({
      //   message: "Please Select At least 1 Group",
      //   type: "danger",
      // });
          toast.error("Please Select At least 1 Group");
    }

    // Map selected group IDs to their corresponding group data
    const selectedGroupsData = selectedGroups
      .map((groupId) => groupsData.find((group) => group.id === groupId))
      .filter((group) => group !== undefined); // Remove any undefined groups

    // Check if all selected groups have 0 members
    const allGroupsEmpty = selectedGroupsData.every(
      (group) => group.member_count === 0 || !group.member_count
    );

    if (allGroupsEmpty && selectedGroupsData.length > 0) {
      // setToastProps({
      //   message: "All selected groups contain 0 members",
      //   type: "danger",
      // });
          toast.error("All selected groups contain 0 members");
      return;
    }

    setButtonDisable(true);

    const url = API_CONTACT_GROUP_MEMBER_UPLOAD.replace(":id", id);
    postApiCall(url, { groupIds: selectedGroups })
      .then(onUploadSuccess)
      .catch(onUploadError);
  };

  function onUploadSuccess(resp) {
    setToastProps({
      message: "Members Uploaded created successfully",
      type: "success",
    });
    setButtonDisable(false);
    setSelectedGroups([]);
    navigate("/contact-group");
  }

  function onUploadError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: "danger" });
          toast.error(JSON.stringify(err));
    }
  }

  const [selectedGroups, setSelectedGroups] = useState([]);

  const handleSelectAll = () => {
    if (selectedGroups.length === groupsData.length) {
      setSelectedGroups([]);
    } else {
      const allGroupsIds = groupsData.map((group) => group.id);
      setSelectedGroups(allGroupsIds);
    }
  };

  const handleCheckboxToggle = (userId) => {
    const isSelected = selectedGroups.includes(userId);
    setSelectedGroups(
      isSelected
        ? selectedGroups.filter((id) => id !== userId)
        : [...selectedGroups, userId]
    );
  };

  return (
    <div className="contact-groups-container">
      <Row>
        <Col sm="12">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-0">
              <div className="header-title px-4 py-3">
                <h4 className="card-title m-0">
                  Import Members from Contacts group
                </h4>
              </div>

              <div className="px-4 py-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                  <Form
                    className="d-flex align-items-center"
                    style={{ width: "300px" }}
                  >
                    <div className="input-group">
                      <span className="input-group-text">
                        <FiSearch />
                      </span>
                      <Form.Control
                        placeholder="Search groups..."
                        type="text"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    </div>
                  </Form>
                </div>
              </div>

              <div className="pb-4 px-4">
                <div style={{ overflowX: "auto" }}>
                  <DataTable
                    value={filteredGroups}
                    scrollable
                    scrollHeight="flex"
                    tableStyle={{ minWidth: "100%" }}
                    paginator
                    rows={10}
                    rowClassName="p-3"
                  >
                    <Column
                      header={
                        <Checkbox
                          checked={
                            selectedGroups.length === groupsData.length &&
                            groupsData.length > 0
                          }
                          onChange={handleSelectAll}
                        />
                      }
                      headerStyle={{ width: "3rem" }}
                      body={(rowData) => (
                        <Checkbox
                          checked={selectedGroups.includes(rowData.id)}
                          onChange={() => handleCheckboxToggle(rowData.id)}
                        />
                      )}
                    />
                    <Column
                      field="group_name"
                      header="Group"
                      sortable
                      style={{ minWidth: "150px" }}
                    />
                    <Column
                      field="member_count"
                      header="Member"
                      sortable
                      style={{ minWidth: "100px" }}
                    />
                    <Column
                      field="group_creator.username"
                      header="Created by"
                      sortable
                      style={{ minWidth: "150px" }}
                    />
                    <Column
                      field="created_at"
                      header="Created on"
                      sortable
                      style={{ minWidth: "200px" }}
                      body={(rowData) =>
                        new Date(rowData.created_at).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                      }
                    />
                  </DataTable>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Button
        variant="primary"
        onClick={handleImportMembers}
        disabled={buttonDisable}
      >
        {buttonDisable ? (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
          ></span>
        ) : (
          "Import Members"
        )}
      </Button>
      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </div>
  );
};

export default ContactGroupList;
